import {
  ChangeDetectionStrategy, Component,
  OnInit
} from '@angular/core';

import { select, Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../../core/core.module';
import { State } from '../../../../vista-usuario/vista-usuario.state';

import {
  Actividad, CurrentEmpresa
} from '@rpe/registro-personas-empresas-lib';

import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { selectAllCurrentEmpresa } from '../../../../empresas/entity-mis-empresas/entity-current-empresa.selectors';
import { RPEPersonaFisica } from '../../../../empresas/entity-personas-fisica/entity-personas-fisica.model';
import { RPEPersonaJuridica } from '../../../../empresas/entity-personas-juridica/entity-personas-juridica.model';
import { entityActividadesAddRequest } from '../../../entity-actividades/entity-actividades.actions';
import { selectAllActividades } from '../../../entity-actividades/entity-actividades.selectors';

@Component({
  selector: 'rpe-entity-registro-actividad-form-container',
  templateUrl: './entity-registro-actividad-form-container.component.html',
  styleUrls: ['./entity-registro-actividad-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityRegistroActividadFormContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  formValid: boolean = false;
  formValueRPEPJ: RPEPersonaJuridica;
  formValueRPEPF: RPEPersonaFisica;

  actividadesConTooltips: {id: number, tipo_actividad: number, nombre: string, checked: boolean, tooltip: string}[] = [
    {
      id: null,
      tipo_actividad: 1,
      nombre: 'almacenamiento',
      checked: false,
      tooltip:
        'Depósito para el almacenamiento de semillas y/o materiales de propagación vegetativa.'
    },
    {
      id: null,
      tipo_actividad: 2,
      nombre: 'comercializacion',
      checked: false,
      tooltip:
        'Comercio de semilla y/o material de propagación vegetativa, cualquiera sea su origen.'
    },
    {
      id: null,
      tipo_actividad: 3,
      nombre: 'criadero_registrante',
      checked: false,
      tooltip:
        'Creación, introducción, mejoramiento, evaluación de especies y cultivares, registro de cultivares y/o registro de propiedad.'
    },
    {
      id: null,
      tipo_actividad: 4,
      nombre: 'experimentacion',
      checked: false,
      tooltip:
        'Realización de ensayos experimentales bajo responsabilidad de la empresa.'
    },
    {
      id: null,
      tipo_actividad: 5,
      nombre: 'exportacion',
      checked: false,
      tooltip:
        'Exportación de semillas, tanto de producción nacional como semilla que haya sido anteriormente importada (contra estación u otros).'
    },
    {
      id: null,
      tipo_actividad: 6,
      nombre: 'importacion',
      checked: false,
      tooltip:
        'Importación de semillas y/o materiales de propagación vegetativa, cualquiera sea el destino de los mismos.'
    },
    {
      id: null,
      tipo_actividad: 7,
      nombre: 'laboratorio',
      checked: false,
      tooltip: 'Laboratorio de análisis de semillas.'
    },
    {
      id: null,
      tipo_actividad: 8,
      nombre: 'procesamiento',
      checked: false,
      tooltip:
        'Maquinación de semillas propias o de terceros, para su limpieza y/o clasificación, así como procesamiento para el agregado de valor a la semilla (inoculación, curado, recubrimiento y peleteado, u otros).'
    },
    {
      id: null,
      tipo_actividad: 9,
      nombre: 'produccion',
      checked: false,
      tooltip:
        'Multiplicación y/o producción de semillas, compra de “semilla en proceso” para producción de lotes nacionales, viveros, etc.'
    },
    {
      id: null,
      tipo_actividad: 10,
      nombre: 'acreditacion',
      checked: false,
      tooltip:
        'Solicitud de adhesión voluntaria para realizar actividades de certificación de semilla en base a los procesos y procedimientos establecidos por INASE.'
    }
  ];

  misActividades: Actividad[] = [];
  private subscription: Subscription | undefined;
  sinTramitePendiente = true;
  idEmpresa: number;
  actividadesFormGroup: FormGroup;

  constructor(
    public store: Store<State>,        
    private router: Router,    
  ) {}


  ngOnInit(): void {
    let resultado = combineLatest([
      combineLatest([
        this.store.pipe(select(selectAllCurrentEmpresa)),
        this.store.pipe(select(selectAllActividades))
      ])
    ]).pipe(
      map(([r1]) => {
        return [...r1] as [CurrentEmpresa[], Actividad[]];
      })
    );
    this.subscription = resultado.subscribe(([currentEmpresa, actividades]) => {
      
      this.idEmpresa = currentEmpresa[currentEmpresa.length - 1].id;
      this.misActividades = actividades.filter(
        (actividad) => actividad.entidad_productiva_id == this.idEmpresa
      );
    
      for (const actividad of this.misActividades) {
        let actToolTips = this.actividadesConTooltips.find(
          (aT) => aT.tipo_actividad === actividad.tipo_actividad_id
        );
        switch (actividad.estado_actividad_id) {
          case 1:
            actToolTips.id = actividad.id;
            actToolTips.checked = true;
            break;
          case 2:
            this.sinTramitePendiente = false;
            break;
          case 3:
            actToolTips.checked = false;
            break;
          default:
            actToolTips.checked = false;
        }
      }      
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  //devuelve si esta seleccionado
  estaSeleccionado(id: number) {
    let encontre = this.misActividades.find((act) => act.id === id);   
    return encontre != undefined;
  }

  onCheckboxChange(event: any, id: number) {
    let actToolTips = this.actividadesConTooltips.find((act) => act.tipo_actividad === id);
    actToolTips.checked = !actToolTips.checked;
  }

  formStatusChanges(status: string) {
    this.formValid = status === 'VALID';
  }

  onSubmit() {
    const seleccionadas = this.actividadesConTooltips.filter(act => act.checked);
    const envio = seleccionadas.map(s => {
      const nuevaA: Actividad = {
        "id": s.id,
        "tipo_actividad_id": s.tipo_actividad,
        "entidad_productiva_id": this.idEmpresa,
        "estado_actividad_id": 1
      }
      return nuevaA;
    });

    const listaActividades = {
      "actividades": envio
    }
    this.store.dispatch(entityActividadesAddRequest({ item: listaActividades }));
    
  }

  onCancel() {

  }
}
